module.exports = __webpack_public_path__ + "static/affordable-price-49ee66afc64a27400fdc4405922af642.png";